import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteRoles as apiDeleteRoles } from "../../api/apiRoles";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteRoles() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: deleteRoles,
        isPending: isDelete,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiDeleteRoles(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["roles"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteRoles, isDelete, error, results };
}
